// extracted by mini-css-extract-plugin
export var buttons = "style-module--buttons--sDfs5";
export var headline = "style-module--headline--kJPO1";
export var imglyTypoButton = "style-module--imgly--typo-button--CokuZ";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--COEFm";
export var imglyTypoH1 = "style-module--imgly--typo-h1--WAg0x";
export var imglyTypoH2 = "style-module--imgly--typo-h2--U747y";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--A7Hal";
export var imglyTypoH3 = "style-module--imgly--typo-h3--pqLfw";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--Ea+zc";
export var imglyTypoH4 = "style-module--imgly--typo-h4--1kFXC";
export var imglyTypoH5 = "style-module--imgly--typo-h5--JWpz9";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--1H5qD";
export var imglyTypoIcon = "style-module--imgly--typo-icon--Rn-9p";
export var imglyTypoLink = "style-module--imgly--typo-link--uOfYs";
export var imglyTypoOverline = "style-module--imgly--typo-overline--nV3dR";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--psD3o";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--btgVs";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--Hj0Z3";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--GYs0X";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--9HTFr";
export var imglyTypoSubline = "style-module--imgly--typo-subline--GF2OC";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--byknu";
export var naviLabelIsLarge = "style-module--navi-label-is-large--0UNUp";
export var naviLabelIsSmall = "style-module--navi-label-is-small--cuYUe";
export var paragraph = "style-module--paragraph--+Lvgp";
export var root = "style-module--root--vD02t";
export var section = "style-module--section--XLdyR";
export var text = "style-module--text--zdyvo";